import type { Labelled } from '../../vocab/VocabularyProvider';

/**
 * Priority as a glyph, as on Or's rows: ⌃⌃ critical, ⌃ high, = medium, ⌄ low.
 * ⚠️ Colour alone is never the carrier — the shape differs too, and the accessible name spells the
 * word out, because a red-green pair is exactly what a colour-blind reader cannot separate.
 */
const GLYPHS: Record<string, { glyph: string; colour: string }> = {
  critical: { glyph: '⌃⌃', colour: '#c9372c' },
  high: { glyph: '⌃', colour: '#e2483d' },
  medium: { glyph: '=', colour: '#e56910' },
  low: { glyph: '⌄', colour: '#1f6bc4' },
};

export function PriorityIcon({ priority }: { priority: Labelled | null }) {
  if (!priority) return null;
  const known = GLYPHS[priority.code];
  const colour = priority.colour ?? known?.colour ?? 'var(--color-ink-subtle)';
  return (
    <span
      title={`Priority: ${priority.label}`}
      aria-label={`Priority: ${priority.label}`}
      style={{ color: colour }}
      className="inline-flex w-5 shrink-0 justify-center text-xs leading-none font-black"
    >
      {known ? known.glyph : priority.label.slice(0, 1).toUpperCase()}
    </span>
  );
}
